import { scrollToId } from "../lib/scroll";

export const LogoMark = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M16 10 H52 L41 22 H29 V27 H44 L34 39 H29 V56 H16 Z" fill="currentColor" />
  </svg>
);

export default function Logo() {
  return (
    <button
      data-testid="nav-logo"
      onClick={() => scrollToId("hero")}
      className="group flex items-center gap-3 text-left"
      aria-label="LF Team — voltar ao topo"
    >
      <img
        src="/logo-mark.png"
        alt="LF Team — logo"
        className="h-9 w-auto shrink-0 object-contain transition-transform duration-300 group-hover:-rotate-6"
      />
      <span className="inline-block leading-none">
        <span className="block whitespace-nowrap font-logo text-base uppercase tracking-[0.3em] text-white md:text-lg">
          LUCAS FUCHT
        </span>
        <span className="mt-1.5 flex items-center justify-between font-mono text-[9px] uppercase text-white/40">
          {"CONSULTORIA PREMIUM".split("").map((c, i) => (
            <span key={i}>{c === " " ? "\u00A0" : c}</span>
          ))}
        </span>
      </span>
    </button>
  );
}
